import { render, staticRenderFns } from "./ThrottleRender.vue?vue&type=template&id=0e4fdc57&"
import script from "./ThrottleRender.vue?vue&type=script&lang=js&"
export * from "./ThrottleRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports